import { EVENT_LEVELS } from '@/modules/Events/constants';
import { rHandler } from '@/plugins/RHandler';

const REQUIRED_AREA_FIELDS = {
  [EVENT_LEVELS.federal]: [],
  [EVENT_LEVELS.regional]: ['region_id'],
  [EVENT_LEVELS.municipal]: ['region_id', 'municipality_id'],
  [EVENT_LEVELS.local]: ['region_id', 'municipality_id'],
};

const positiveId = (value) => {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : null;
};

export const getEventAreaIds = (record) => ({
  region_id: positiveId(record?.region?.id ?? record?.region_id ?? record?.response?.region_id),
  municipality_id: positiveId(record?.municipality?.id ?? record?.municipality_id ?? record?.response?.municipality_id),
});

export const hasRequiredEventArea = (level, area) => {
  const fields = REQUIRED_AREA_FIELDS[Number(level?.id ?? level)];
  return !!fields && fields.every((field) => !!positiveId(area?.[field]));
};

export const getEventAreaParams = ({ event, form = {}, user }) => {
  const level = Number(form.level ?? event?.level?.id ?? event?.level);
  if (level === EVENT_LEVELS.local) {
    const organizer = user?.data?.organizer;
    const organizationId = positiveId(event?.organization?.id) || positiveId(event?.response?.organization_id);
    const organizerId = positiveId(organizer?.id ?? organizer?.response?.id);
    const sources = [event?.organization];
    if (!organizationId || organizationId === organizerId) sources.push(organizer);
    sources.push(event?.area);
    return sources.map(getEventAreaIds).find((area) => hasRequiredEventArea(level, area)) || getEventAreaIds();
  }

  return {
    region_id: [EVENT_LEVELS.regional, EVENT_LEVELS.municipal].includes(level) ? positiveId(form.region_id) : null,
    municipality_id: level === EVENT_LEVELS.municipal ? positiveId(form.municipality_id) : null,
  };
};

export const validateEventArea = (level, area) => {
  if (hasRequiredEventArea(level, area)) return null;
  return rHandler(
    Promise.reject(new Error('Не удалось определить территорию мероприятия. Проверьте регион и муниципалитет.')),
    undefined,
    (error) => ({ error }),
  );
};
